import { IconProps } from '@models/icons';

function CartLine({ size = 30, color = '#6E6864', ...rest }:IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <path d="M23.2612 9.10352C25.5313 9.10352 27.2395 11.1725 26.8091 13.4014L24.9399 23.0742C24.6907 24.3641 23.5613 25.2969 22.2476 25.2969H8.75244C7.43885 25.2967 6.30922 24.364 6.06006 23.0742L4.19092 13.4014C3.76057 11.1727 5.46892 9.10375 7.73877 9.10352H23.2612ZM7.73877 11.1035C6.72557 11.1038 5.96264 12.0276 6.15478 13.0225L8.02392 22.6953C8.09135 23.0441 8.39718 23.2967 8.75244 23.2969H22.2476C22.603 23.2969 22.9086 23.0443 22.9761 22.6953L24.8452 13.0225C25.0374 12.0274 24.2746 11.1035 23.2612 11.1035H7.73877Z"
                  fill={color}/>
            <path d="M11.1453 15.2419V18.7256" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15.4998 15.2422V18.7259" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.8544 15.2422V18.7259" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.3728 9.70312V8.70312C11.3728 6.49399 13.1637 4.70312 15.3728 4.70312C17.582 4.70312 19.3728 6.49399 19.3728 8.70312V9.70312" stroke={color} strokeWidth="2"/>
        </svg>
  );
}
export default CartLine;
